'use client';

import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
import useModalStore from '@module/stores/useModalStore';
import { MODAL_TYPE_PC } from '@module/types/modal/type';
import { usePathname, useRouter } from 'next/navigation';
import { type FormEvent, useEffect, useRef } from 'react';
function MainSearchInput() {
  const $ = _c(11);
  const pathname = usePathname();
  const isMyPage = pathname.includes("/my");
  const isChannelPage = pathname.includes("/channel");
  const isCustomerPage = pathname.includes("/customer");
  const shouldSearchInputHide = isMyPage || isChannelPage || isCustomerPage;
  const pushModal = useModalStore(_temp);
  const searchInputRef = useRef(null);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      if (!searchInputRef.current) {
        return;
      }
      if (pathname.includes("/search")) {
        const url = new URL(window.location.href);
        const textValue = url.searchParams.get("text");
        searchInputRef.current.value = decodeURIComponent(textValue || "");
      } else {
        searchInputRef.current.value = "";
      }
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== pathname || $[4] !== pushModal || $[5] !== router) {
    t2 = e => {
      e.preventDefault();
      if (!searchInputRef.current) {
        return;
      }
      searchInputRef.current?.blur();
      const formData = new FormData(e.currentTarget);
      const inputValue = formData.get("search");
      if (typeof inputValue !== "string" || inputValue.trim().length < 2) {
        pushModal({
          type: MODAL_TYPE_PC.CONFIRM_MODAL,
          id: "MainSearchInput",
          options: {
            description: "\uAC80\uC0C9\uC5B4\uB294 2\uC790 \uC774\uC0C1 \uC785\uB825\uD574 \uC8FC\uC138\uC694."
          }
        });
        return;
      }
      const searchUrl = `/search/live?text=${encodeURIComponent(inputValue.trim())}`;
      if (pathname.includes("/search/bj")) {
        const searchBjUrl = `/search/bj?text=${encodeURIComponent(inputValue.trim())}`;
        router.push(searchBjUrl);
      } else {
        if (pathname.includes("/play/")) {
          window.open(searchUrl, "_blank", "noopener");
        } else {
          router.push(searchUrl);
        }
      }
    };
    $[3] = pathname;
    $[4] = pushModal;
    $[5] = router;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onSubmit = t2;
  if (shouldSearchInputHide) {
    return null;
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <input ref={searchInputRef} placeholder={"\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694."} name="search" className="h-[40px] w-full rounded-lg pr-2 text-[14px] text-baseFg focus:outline-none focus:ring-0" />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <button type="submit" className="flex h-[40px] w-[40px] items-center justify-center"><img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/search_gray.png`} alt="search" width={14} /></button>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onSubmit) {
    t5 = <form className="flex w-[400px] items-center rounded-lg bg-colorBg09 pl-4" onSubmit={onSubmit}>{t3}{t4}</form>;
    $[9] = onSubmit;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp(state) {
  return state.pushModal;
}
export default MainSearchInput;